import { useFormik } from "formik";
import { LocationFormValues } from "../types";

export function useLocationForms() {
	const initialValues: LocationFormValues = {
		name: "",
		stationRegion: "",
		regionId: 0,
		macroRegionId: 0,
		locationId: undefined,
		geofence: undefined,
	};

	const formikCreate = useFormik({
		initialValues,
		onSubmit: () => { },
	});

	const formikEdit = useFormik({
		initialValues,
		onSubmit: () => { },
	});

	return {
		formikCreate,
		formikEdit,
	};
}
